<header class="vincent_header">
    <div class="row ">
        <div class="col col-3 vincent_header_left">
            <div class="vincent_inner">
                <div class="vincent_inner_h_contact xx">
                    <div class="vincent_h_phone">+05 03 66 74 01</div>
                    <div class="vincent_h_wh">8:00 am – 11:30 pm</div>
                </div>
            </div>
        </div>
        <div class="col col-6 vincent_header_center">
            <div class="vincent_def_header">
                <div class="vincent_logo_cont">
                    <a routerLink="/">
                        <img src="assets/imgs/logo.png" class="x_logo">
                    </a>
                </div>
                <nav class="vincent_menu_cont">
                    <a class="toggle" (click)="open()" style="display: none;" *ngIf="Open == true"><mdb-icon far icon="caret-square-down"></mdb-icon></a>
                    <a class="toggle" (click)="close()" style="display: none;" id="close-btn" *ngIf="Close == true"><mdb-icon far icon="caret-square-up"></mdb-icon></a>
                    <ul class="vincent_menu_ar" id="menu" *ngIf="ulTrue == true">
                        <li class="menu-item menu-item-has-children">
                            <a routerLink="/" routerLinkActive="activeX" [routerLinkActiveOptions]="{exact:true}">{{"Home" | translate}}</a> 
                       </li>
                        <li class="menu-item menu-item-has-children">
                            <a routerLink="/menu" routerLinkActive="activeX" [routerLinkActiveOptions]="{exact:true}">{{"Menu_list" | translate}}</a>
                        </li>
                        <li class=" menu-item menu-item-has-children">
                            <a routerLink="/gallery" routerLinkActive="activeX" [routerLinkActiveOptions]="{exact:true}"> {{"Gallery" | translate}}</a>
                        </li>
                        <li class="menu-item menu-item-has-children">
                            <a routerLink="/about" routerLinkActive="activeX" [routerLinkActiveOptions]="{exact:true}">  {{"About" | translate}}</a>
                        </li>

                        <li class="menu-item menu-item-has-children">
                            <a routerLink="/contact" routerLinkActive="activeX" [routerLinkActiveOptions]="{exact:true}">{{"Contact" | translate}}</a>
                        </li>
                        <li class="menu-item menu-item-has-children" *ngIf="ar == true" (click)="show_ar()" id="ar">
                            <a (click)="changeCurrentLang('ar')">
                                <img src="assets/imgs/ar.png" style="width: 25px; position: relative; bottom: 5px;" >
                           </a>
                        </li>
                        <li class="menu-item menu-item-has-children" *ngIf="en == true" (click)="show_en()" id="en">
                            <a (click)="changeCurrentLang('en')">
                                <img src="assets/imgs/en.png" style="position: relative; bottom: 5px;">
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="clear"></div>
            </div>
        </div>
        <div class="col col-3 vincent_header_x" id="vincent_header_right">
            <div class="vincent_inner">
                    <div class="vincent_shopping_cart" id="shopping_cart" *ngIf="isUser">
                       
                        <div class="vincent_total_items">
                            <a routerLink="/cart" class="show_cart">
                                {{"Cart" | translate}}
                            </a>
                        </div>

                        <div class="vincent_total_items"> 
                            <span class="xxxx">{{"Table_no" | translate}}  - </span>    
                            <input type="number" class="table-no-form cc" [(ngModel)]="tableno" min="0" max="15">
                        </div>

                        <div class="vincent_total_items" id="basic">
                            <a (click)="updateNo(tableno)">
                                {{"Change_Table_no" | translate}}
                            </a>
                        </div>
                          
                        <div class="vincent_total_items ffc851" id="changed" style="display: none;">
                            {{"Done_Change_Table_no" | translate}}
                        </div>
                        
                        <div class="vincent_cart_item_counter" (click)="goCart()">{{ length }}</div>
                    
                    </div>

                <a (click)="logout()" class="vincent_button btns xxx" *ngIf="isUser" id="logout">{{"Log_out" | translate}}</a>
                    
                <div class="vincent_total_price" *ngIf="!isUser">
                    <a routerLink="/login" class="vincent_button btns xxx">
                        {{"Log_in" | translate}}
                    </a>
                </div>

                <!-- <div *ngIf="ar == true" (click)="show_ar()" id="ar" class="switch-lang">
                     <a (click)="changeCurrentLang('ar')">
                         <img src="assets/imgs/ar.png" style="width: 25px;">
                    </a>
                </div>

                <div *ngIf="en == true" (click)="show_en()" id="en" class="switch-lang">
                    <a (click)="changeCurrentLang('en')">
                        <img src="assets/imgs/en.png">
                    </a>
                </div> -->


            </div>
        </div>
    </div>
    <div class="vincent_corners"></div>
</header>